<template>
  <div class="row">
    <div class="card" v-show="!isLoading">
      <div class="card-body" style="padding: 20px 20px 100px 20px;">
        <div class="row">
          <!-- Modal: Edit Course Info -->
          <EditCourseInfo v-if="isTeacher"></EditCourseInfo>
        </div>
        <div class="row">
          <div v-show="!!courseInfo.cover_photo_url" class="col-md-5" style="display: 'block':'none';">
            <img class="img-responsive" :src="courseInfo.cover_photo_url" style="max-height: 300px; margin: auto;"/>
          </div>
          <div class="col-md-7">
            <span style="font-weight:bold; margin:0px; color:#7e8082; overflow-wrap: break-word; font-size: 24px; line-height: 32px; font-family: 'Roboto','Helvetica','Arial',sans-serif">{{courseInfo.name}}</span>
            <div v-show="!!courseInfo.summary" style="margin-top:15px; margin-right:15px; overflow-wrap: break-word;">
              <p style="font-size: 14pt; font-weight: 550; color: var(--dark-color);">班級簡介</p>
              <p>{{courseInfo.summary}}</p>
            </div>
          </div>
        </div>
        <div class="row" style="margin-top:25px">
          <div class="col-md-12">
            <video v-show="!!courseInfo.video_url" :src="courseInfo.video_url" style="width: 100%; max-width: 320px;" controls>
            </video>
          </div>
        </div>
        <div class="row" style="margin-top:25px">
          <!-- Modal: Edit Teacher Info -->
          <EditInstructor v-if="isTeacher"></EditInstructor>
          <!-- <EditInstructor v-if="courseInfo.permissions.edit_instructor_info"></EditInstructor> -->
          <div class="col-md-12">
            <p style="font-size: 14pt; font-weight: 550; color: var(--dark-color);">老師簡介</p>
          </div>

          <div v-for="instructor in courseInfo.instructors" :key="instructor.email" class="col-md-12" :class="instructor.is_self?'self':''" style="margin: 10px;">
            <div class="col-md-3">
              <img class="profile_img" :src="!!instructor.profile_img?instructor.profile_img:`${api_url}/assets/images/icon_users.png`" style="width:80px">
            </div>
            <div class="col-md-9">
              <div style="font-size: 16px;"> {{ `${instructor.first_name} ${instructor.last_name}` }}</div>
              <p class="summary" style="max-height: 80px; overflow-y: auto;">{{ instructor.summary }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading v-show="isLoading"></Loading>
  </div>
</template>

<script>
import EditCourseInfo from '@/components/CourseInfo/EditCourseInfo'
import EditInstructor from '@/components/CourseInfo/EditInstructor'
import Loading from '@/components/Utility/Loading.vue'
export default {
  components: {
    Loading,
    EditCourseInfo,
    EditInstructor
  },
  data () {
    return {
      isLoading: true,
      api_url: this.$store.state.api_url,
      courseId: this.$parent.courseId,
      courseInfo: [],
      myInfo: null,
      isTeacher: this.$store.getters.isTeacher
    }
  },
  methods: {
    updateMyInfo: function (myInfo) {
      for (let key in this.courseInfo.instructors) {
        if (this.courseInfo.instructors[key].is_self) {
          this.myInfo = myInfo
          this.courseInfo.instructors[key] = myInfo
        }
      }
    }
  },
  mounted: async function () {
    try {
      await this.$store.dispatch('request', {
        route: `courses/${this.courseId}`
      }).then(res => {
        this.courseInfo = res
        for (let userInfo of this.courseInfo.instructors) {
          if (userInfo.is_self) {
            this.myInfo = userInfo
          }
        }
      })
    } catch (err) {
      console.log(err)
      alert('更新失敗')
    }
    this.isLoading = false
  }
}
</script>
